import ApiConstants from "../../constants/ApiConstant";
import { apiGet, apiPost } from "../../services/apiService";

export const addContactUsAPI = (data, callBack) => {
    return async () => {
      try {
        await apiPost(ApiConstants.contactUsUrl, data)
          .then((response) => {
            callBack && callBack(response?.data, response?.data);
          })
          .catch((err) => {
            console.error("get dashboard details api err===-=>>>:", err);
            throw err;
          });
      } catch (err) {
        console.error("get dashboard details api err:", err);
        throw err;
      }
    };
  };


  export const addHiringAPI = (data, callBack) => {
    return async () => {
      try {
        await apiPost(ApiConstants.hiringUrl, data)
          .then((response) => {
            callBack && callBack(response?.data, response?.data);
          })
          .catch((err) => {
            console.error("get dashboard details api err===-=>>>:", err);
            throw err;
          });
      } catch (err) {
        console.error("get dashboard details api err:", err);
        throw err;
      }
    };
  };


  export const getAllPositionAPI = (data, callBack) => {
    return async () => {
      try {
        await apiGet(ApiConstants.getAllPositionUrl, data)
          .then((response) => {
            callBack && callBack(response?.data, response?.data);
          })
          .catch((err) => {
            console.error("get dashboard details api err===-=>>>:", err);
            throw err;
          });
      } catch (err) {
        console.error("get dashboard details api err:", err);
        throw err;
      }
    };
  };